<template>
  <div id=center>
    <div></div>
    <div id="sign" name="sign" class="sign">
      <div @click="gotoSign(1)" class="goSign">
        <img src="/static/img/user/center/signMul.png">
        <span>发起多方签署</span>
      </div>

      <div @click="gotoSign(2)" class="goSign">
        <img src="/static/img/user/center/signSingle.png">
        <span>发起单方签署</span>
      </div>
    </div>
    <div class="fileAndexperience">
      <div id="myFiles" class="myFiles">
        <div class="myFile">我的文件</div>
        <div class="viewAll" @click="viewContract('total')">查看全部</div>
        <hr/>
        <div>
          <div id="waitMeSign" class="waitMeSign">
            <p><span>{{ waitMeSign }}</span></p>
            <div @click="viewContract('dwqs')" class="waitMe">待我签署</div>
          </div>
          <div id="waitOtherSign" class="waitOtherSign">
            <p><span>{{ waitOtherSign }}</span></p>
            <div @click="viewContract('dtrqs')" class="waitOther" >待他人签署</div>
          </div>
        </div>

      </div>
      <div class="experience">
        <div class="exp">快速体验
        </div>
        <div class="end addexp">
          <img src="/static/img/user/center/approval.png"/>
          <div class="centercont fl">实名认证</div>
          <div class="appstatus fr" @click="gotoApproval">{{approvalStatus}}</div>
        </div>
        <div class="cl"></div>
        <div class="end addexp">
          <img src="/static/img/user/center/createSign.png"/>
          <div class="centercont fl">创建签名</div>
          <div class="appstatus fr" @click="gotoViewAndCreateMySign">{{signCreateStatus}}</div>
        </div>
        <div class="cl"></div>
        <div class="end">
          <img src="/static/img/user/center/combolast.png"/>
          <div class="centercont fl">套餐剩余{{signNum}}次</div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  import {Toast,MessageBox} from 'mint-ui';
  import { userStatus, userStatusObj } from '@/config/userStatus'
  import cheader from '@/components/header';
  import clogo from '@/components/logo';
  import { getCookie } from '@/js/utils.js'
  export default {
    name: 'center',
    data () {
      return {
        waitMeSign: 0,
        waitOtherSign: 0,
        signNum: 0,
        approvalStatus: '去认证',
        signCreateStatus: '去创建',
        attestation:'',
        status: '0', // 认证状态码
      }
    },
    methods: {
      viewContract(param){
        if(param=='dwqs'){
          this.$emit('message', '1');
        }else if(param=='dtrqs'){
          this.$emit('message', '2');
        }else{
          this.$emit('message', '0');
        }
      },
      gotoApproval: function () {
        userStatus(this.status, ['0'], () => {
          if (this.status === '0') {
            this.$router.push({
                path: '/realName',
            })
          }
        })
      },
      async gotoSign(fileType){
        let that=this;
        // 0 未认证 （ 未认证 ） 1 个人认证（ 已认证 ） 2 正常企业认证待审核( 基础信息审核中 (其实是未认证) ) 3 企业已认证需要完善信息（ 已认证待完善 ） 4 完善信息待审核( 认证信息审核中 （其实是已认证待完善） ) 5 正常企业认证被拒绝（ 基础信息已拒绝 (其实是未认证 ） 6 完善信息审核被拒绝（ 认证信息已拒绝 （其实是已认证待完善）） 7 企业认证成功（ 已认证 ） 8 个人已认证需要完善信息（ 已认证待完善 ）
        userStatus(this.status, ['1', '2', '3', '4', '5', '6', '7', '8'], () => {
          if (this.status === '2' || this.status === '5') {
            MessageBox.confirm('', { 
                 message: '您还未通过实名认证，请先通过实名认证！', 
                 title: '提示', 
                 confirmButtonText: '去认证', 
                 cancelButtonText: '取消' 
              }).then(action => { 
                  if (action == 'confirm') {
                    this.$router.push({
                      path: '/realName',
                      query: {
                        type: 'ENTERPRISE'
                      }
                    })
                  }
              }).catch(err => { 
                  if (err == 'cancel') {
                   console.log('取消');
                  } 
              });
          } else if (this.status === '3' || this.status === '4' || this.status === '6') {
            MessageBox.confirm('', { 
                 message: '根据平台要求，您需要完善企业实名信息后方可继续签约', 
                 title: '提示', 
                 confirmButtonText: '去完善', 
                 cancelButtonText: '取消' 
              }).then(action => { 
                  if (action == 'confirm') {
                    this.$router.push({
                      path: '/realName',
                      query: {
                        type: 'ENTERPRISE'
                      }
                    })
                  }
              }).catch(err => { 
                  if (err == 'cancel') {
                   console.log('取消');
                  } 
              });
          } else if (this.status === '8') {
            MessageBox.confirm('', { 
                 message: '根据平台要求，您需要完善个人实名信息后方可继续签约', 
                 title: '提示', 
                 confirmButtonText: '去完善', 
                 cancelButtonText: '取消' 
              }).then(action => { 
                  if (action == 'confirm') {
                    this.$router.push({
                      path: '/realName',
                      query: {
                        type: 'PERSON',
                        identifyType: '1'
                      }
                    })
                  }
              }).catch(err => { 
                  if (err == 'cancel') {
                   console.log('取消');
                  } 
              });
          } else {
            this.$router.push({
              path: '/sign/uploadFile',
              name: 'uploadFile',
              query: {
                fileType: fileType,
                _router: {
                  name: 'main',
                  path: "/main"
                }
              }
            })
          }
        })
        // if(this.attestation==='8'){
        //     MessageBox.confirm('', { 
        //        message: '根据平台要求，您需要完善个人实名信息后方可继续签约', 
        //        title: '提示', 
        //        confirmButtonText: '去完善', 
        //        cancelButtonText: '取消' 
        //     }).then(action => { 
        //         if (action == 'confirm') {
        //           this.$router.push({
        //             path: '/realName',
        //             query: {
        //               type: 'PERSON',
        //               identifyType: '1'
        //             }
        //           })
        //         }
        //     }).catch(err => { 
        //         if (err == 'cancel') {
        //          console.log('取消');
        //         } 
        //     });
        // } else if (this.attestation==='3') {
        //   MessageBox.confirm('', { 
        //        message: '根据平台要求，您需要完善企业实名信息后方可继续签约', 
        //        title: '提示', 
        //        confirmButtonText: '去完善', 
        //        cancelButtonText: '取消' 
        //     }).then(action => { 
        //         if (action == 'confirm') {
        //           this.$router.push({
        //             path: '/realName',
        //             query: {
        //               type: 'ENTERPRISE'
        //             }
        //           })
        //         }
        //     }).catch(err => { 
        //         if (err == 'cancel') {
        //          console.log('取消');
        //         } 
        //     });
        // }else{
        //     this.$router.push({
        //       path: '/sign/uploadFile',
        //       name: 'uploadFile',
        //       query: {
        //         fileType: fileType,
        //         _router: {
        //           name: 'main',
        //           path: "/main"
        //         }

        //       }
        //     })
        // }
      },
      fetcchMsg: function () {
        console.log('我被执行了---center---')
        let that = this
        var _mainIndex_Url = domain("_mainIndex"); //个人中心数据
        this.$http.post(
          _mainIndex_Url,
          {emulateJSON: true}
          )
          .then(function (response) {
            console.log(response);
            console.log('---------------------')
            var code = response.body.code;
            var msg = response.body.msg;
            if (code == '0') {
              
              var returnDate = response.body.data;
              var approveStatus = returnDate.approveStatus;
              that.status = approveStatus
              // 0 未认证 （ 未认证 ） 1 个人认证（ 已认证 ） 2 正常企业认证待审核( 基础信息审核中 ) 3 企业已认证需要完善信息（ 已认证待完善 ） 4 完善信息待审核( 认证信息审核中 ) 5 正常企业认证被拒绝（ 基础信息已拒绝 ） 6 完善信息审核被拒绝（ 认证信息已拒绝 ） 7 企业认证成功（ 已认证 ） 8 个人已认证需要完善信息（ 已认证待完善 ）
              this.approvalStatus = userStatusObj[that.status].clientName
              // if (approveStatus == '1'||approveStatus == '7') {
              //   //认证成功
              //   this.approvalStatus = "认证成功";
              // } else if (approveStatus == '3') {
              //   this.approvalStatus = "企业实名已认证，去完善";
              //   this.attestation = approveStatus
              // } else if (approveStatus == '5'||approveStatus == '6') {
              //   this.approvalStatus = "认证驳回";
              // } else if (approveStatus == '2'||approveStatus == '4') {
              //   this.approvalStatus = "审核中";
              // } else if(approveStatus == '8'){
              //   this.approvalStatus = "已认证，去完善";
              //   this.attestation = approveStatus;
              // }

              this.signNum = returnDate.signNum;
              this.waitMeSign = returnDate.total1;
              this.waitOtherSign = returnDate.total2;
              if(response.body.data.synFlag=='0'){
                this.$TsaDialog.show({
                  message: '根据平台要求，您需要绑定手机号后方可继续签约',
                  confirmBtnText: '去绑定',
                  onConfirm: () => {
                    let access_token = getCookie('access_token')
                    window.location.href=process.env.USER_ACCOUNT+'/userCenter/associationPhone?type=phone&clientId=925220&access_token='+access_token
                    this.$TsaDialog.hide()
                  },
                  onCancel: () => {
                    window.location.href='/api/logout';
                  }
                })
                return
              }
              // 0 不弹 1 弹
              if (response.body.data.needSupplement === 1) {
                this.$TsaDialog.show({
                  confirmBtnText: '继续',
                  message: '<p class="nomalClass">根据《关于开展电子认证服务合规性专项整治工作的通知》要求，请您完善并提交以下相关资料，以便继续使用联合信任电子签名相关服务。</p>',
                  onConfirm: () => {
                    let access_token = getCookie('access_token')
                    window.location.href =  process.env.VUE_APP_USER_ACCOUNT_PC + '/enterpriseCation?clientId=925220&access_token='+access_token
                    this.$TsaDialog.hide()
                  },
                  onCancel: () => {
                    window.location.href='/api/logout';
                  }
                })
              }
              var rs = returnDate.rs;
              if (rs == '1') {
                this.signCreateStatus = "查看";
              }
            } else {
              Toast(msg)
            }
          }, function (error) {
            console.log(error);
          }).catch(function (response) {
          console.log(response);
        })
      },
      gotoViewAndCreateMySign: function () {
        this.$router.push({
          path: '/user/mySign',
          name: 'mySign',
          query: {
            _router: {
              name: 'main',
              path: "/main"
            }

          }
        })
      }

    },
    components: {
      cheader,
      clogo
    },
    created: function () {
      this.fetcchMsg();
    },
    beforeDestroy () {
      this.$TsaDialog.hide()
    }
  }
</script>
<style>
  .btnNomal {
    color: #000;
  }
  #center .logo {
    background-color: #ffffff;
  }

  #center {
    height: 100%;
    font-size: 0.8rem;
    font-family: "Microsoft YaHei";
    background-color: #ECECEC;
    margin-bottom: 115px;
  }

  #center .sign {
    position: absolute;
    width: 100%;
    background-color: #26a2ff;
    height:140px;
    top:0;
    background-image: url("/static/img/centerbg.jpg");
  }

  .sign .goSign {
    width: 50%;
    float: left;
    text-align: center;
  }

  .sign .goSign img {
    margin-top: 35px;
    width: 45px;
  }

  .sign .goSign span {
    display: block;
    margin-top: 10px;
    color: #FFFFFF;
  }

  .fileAndexperience {
    margin-top: 150px;
    width: 100%;
  }

  .myFiles {
    width: 96%;
    height: 120px; /*6em × 10 = 60px */
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
    margin-left: 2%;
    background-color: #FFFFFF;
    border-color: rgba(215, 215, 215, 1);

  }

  .myFiles .myFile {
    width: 45%;
    margin-left: 2%;
    margin-top: 1%;
    float: left;
    font-size: 0.9rem;
    color: #7d7d7d;
  }

  .myFiles .viewAll {
    width: 45%;
    float: left;
    margin-right: 2%;
    margin-top: 1%;
    padding-bottom: 2%;
    text-align: right;
    color: #c1c1c1;
    float: right;
    font-size: 0.8rem;
  }

  .myFiles hr {
    margin-top: 13%;
    width: 94%;
    margin: 0 auto
  }

  .waitMeSign {
    display: inline;
    margin-top: 25px;
    width: 50%;
    float: left;
    text-align: center;
  }

  .waitMeSign span {
    display:inline;
    font-size: 1rem;
    font-family: "Arial";
    color: #7d7d7d;
  }

  .waitMeSign .waitMe {
    display:inline;
    color: #7d7d7d;
    font-size: 1rem;
    color: #c1c1c1;
  }

  .waitOtherSign {
    margin-top: 25px;
    width: 50%;
    float: left;
    text-align: center;
  }

  .waitOtherSign span {
    display: block;
    font-size: 1rem;
    font-family: "Arial";
    color: #7d7d7d;
  }

  .waitOtherSign .waitOther {
    display: inline;
    color: #7d7d7d;
    margin-top: 2%;
    font-size: 1rem;
    color: #c1c1c1;
  }

  .experience {
    margin-top: 10px;
    margin-left: 2%;
    background-color: #FFFFFF;
    border-radius: 5px;
    border-color: rgba(215, 215, 215, 1);
    width: 96%;
    color: #7d7d7d;
    font-size: 1.1rem;
  }

  .exp {
    height: 50px;
    width: 96%;
    margin: 0 auto;
    border-bottom: thin dashed #c1c1c1;
    line-height: 50px;
    font-size: 1rem;
  }
  .addexp{
    border-bottom: thin dashed #c1c1c1;
  }
  .exp img {
    float: left;
    margin-top: 12px;
    padding-right: 10px;
  }

  .end {
    height: 50px;
    width: 90%;
    margin: 0 auto;
    line-height: 50px;
    font-size: 1rem;
  }

  .end img {
    float: left;
    margin-top: 15px;
    padding-right: 10px;
    width:25px;
  }
  .appstatus{
    float: right;font-size: 0.8rem;color: #26a2ff;
    margin-top: 4px;
  }
  .centercont{
    display: inline-block;font-size: 0.9rem;
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/module/user/center.vue